import * as types from "./CargoActionType";
const initialState = {
    consignmentList: [],
}
const TopUpReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.CONSIGNMENT_LIST:
            return {
                ...state,
                consignmentList: [...action.payload]
            };
        default:
            return state;
    }
}

export default TopUpReducer
